import { render, staticRenderFns } from "./EditPerfil.vue?vue&type=template&id=757c7eb3&"
import script from "./EditPerfil.vue?vue&type=script&lang=js&"
export * from "./EditPerfil.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports